import React, { Component } from "react";

import Avatar from "../home/Avatar";
import resumeImage from "../../assets/images/resume_image.jpeg";

import ResumeMain from "./ResumeMain";
import "./Resume.scss";
export class Resume extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="resume-container text-center">
                <div className="row w-100 p-0 m-0 h-100 d-flex flex-row justify-content-center">
                    <div className="col-md-4 pt-5 col-sm-12 bg-transparent d-flex flex-column">
                        <div className=" d-flex flex-column p-0 m-0 align-items-center justify-content-center">
                            <div className="mage-image-container p-0 m-0">
                                <Avatar className="p-0 m-0 w-100 h-100" image={resumeImage} alt="Sahan Amarsha" />
                            </div>
                            <p className="header-name" >Sahan Amarsha</p>
                            <p className="header-profession" >Developer</p>
                        </div>
                        <div className=" resume-content-container p-0 m-0">
                            <hr />
                            <p className="my-desc">Well, Now I'm studying for my degree, Bsc. in Information Technology. I always wanted to be in the industry as a developer. I don't want to recognize in the field as a 'Full Stack Developer' or a 'Mobile App Developer'. I have my aim on being a Full Stack Web Developer, Mobile App Developer and also a Game Developer. I'm enhancing my knowledge in these fields. Also, I have a touch of curiosity in 'Data Structures and Algorithms'...</p>
                        </div>

                    </div>
                    <div className="col-md-8 col-sm-12 resume-exp-container p-4">
                        <ResumeMain />
                    </div>
                </div>
            </div>
        );
    }
}

export default Resume;
